import React, { JSX } from 'react';
import { useSitecore, Field } from '@sitecore-content-sdk/nextjs';
import ComponentWrapper from 'helpers/SitecoreWrappers/ComponentWrapper/ComponentWrapper';
import ProviderReviews from 'helpers/Reviews/ProviderReviews';

const RatingsAndReviews = (): JSX.Element => {
  // Access the context item (the Provider Profile page item)
  const { page } = useSitecore();
  const contextItem = page?.layout?.sitecore?.route?.fields;

  const npiField = contextItem?.npi as Field<string>;
  const whyNoRatingsField = contextItem?.whyNoRatings as Field<string>;

  return (
    <ComponentWrapper
      isSidenavPart={true}
      className="reviews-and-ratings"
      aria-label={`Provider Profile Ratings and Reviews`}
      role="region"
    >
      {npiField && (
        <ProviderReviews
          npi={npiField}
          whyNoRatings={whyNoRatingsField}
          variant="full-details"
          profilePageUrlOrAnchorId="throw-this-away"
        />
      )}
    </ComponentWrapper>
  );
};

export default RatingsAndReviews;
